"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SummaryColumnSection = exports.SummaryCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _CTASection = _interopRequireDefault(require("../CTASection/CTASection"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SummaryCard = (summaryCard, labels, version, variant) => {
  const {
    name,
    description,
    productLine,
    regions,
    cta,
    ctas
  } = summaryCard;
  const external = (0, _checkForExternalLink.default)(cta?.url);
  const renderRegions = () => {
    if (!regions) {
      return /*#__PURE__*/_react.default.createElement("p", {
        className: "product-summary-card--container__regions--region-name"
      }, labels?.noRegionsLabel);
    }
    return regions.map((region, i) => {
      return /*#__PURE__*/_react.default.createElement("p", {
        key: i,
        className: "product-summary-card--container__regions--region-name"
      }, region);
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container__name"
  }, labels?.productSummaryLabel && /*#__PURE__*/_react.default.createElement("h2", {
    className: "product-summary-card--container__name-label"
  }, labels?.productSummaryLabel), name && /*#__PURE__*/_react.default.createElement("h3", {
    className: "product-summary-card--container__name-text",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(name)
  }), description && /*#__PURE__*/_react.default.createElement("p", {
    className: "product-summary-card--container__name-description",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(description)
  })), productLine && !variant && /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container__line"
  }, labels?.productLineLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container__line-label"
  }, labels?.productLineLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container__line-text",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(productLine)
  })), productLine && variant && /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container__line"
  }, labels?.productLineLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container__line-label"
  }, labels?.productLineLabel), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex"
    }
  }, renderClock(variant), /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container__line-text",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(productLine)
  }))), regions && regions?.length && /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container__regions"
  }, labels?.regionsLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container__regions-label"
  }, labels?.regionsLabel), renderRegions()), cta && /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container__link"
  }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    className: external ? "text-link-external" : "text-link",
    to: cta?.url,
    onClick: cta?.onClick
  }, cta?.text)), ctas && /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card--container__link"
  }, ctas && /*#__PURE__*/_react.default.createElement(_CTASection.default, {
    ctas: ctas
  }))), version && /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-card__version"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "product-summary-card__version-text"
  }, version)));
};
exports.SummaryCard = SummaryCard;
const SummaryColumnSection = columns => {
  if (!columns || !columns?.length) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return columns.map((column, i) => {
    return summaryColumn(column, i);
  });
};
exports.SummaryColumnSection = SummaryColumnSection;
const summaryColumn = (column, i) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-column",
    key: i
  }, column?.eyebrow && /*#__PURE__*/_react.default.createElement("h2", {
    className: "product-summary-column__eyebrow"
  }, column?.eyebrow), column?.header && /*#__PURE__*/_react.default.createElement("h3", {
    className: "product-summary-column__header",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(column?.header)
  }), column?.subheader && /*#__PURE__*/_react.default.createElement("div", {
    className: "product-summary-column__subheader",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(column?.subheader)
  }), /*#__PURE__*/_react.default.createElement("ul", {
    className: "product-summary-column__bullets-container"
  }, renderBulletsOrLinks(column?.listType, column?.list)));
};
const renderBulletsOrLinks = (type, list) => {
  if (list && list.length) {
    if (type === "links") {
      return list.map((item, i) => {
        const external = item?.type && item?.type === "pdf" ? true : (0, _checkForExternalLink.default)(item?.url);
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "product-summary-column__bullets",
          key: i
        }, /*#__PURE__*/_react.default.createElement("a", {
          className: external ? "product-summary-column__bullets-link-external" : "product-summary-column__bullets-link",
          target: external ? "_blank" : "_self",
          href: item?.url,
          dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(item?.text)
        }));
      });
    }
    if (type === "bullets") {
      return list.map((item, i) => {
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "product-summary-column__bullets",
          key: i
        }, item?.title && /*#__PURE__*/_react.default.createElement("h4", {
          className: "product-summary-column__bullets-header",
          dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(item?.title)
        }), item?.text && /*#__PURE__*/_react.default.createElement("p", {
          className: "product-summary-column__bullets-text",
          dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(item?.text)
        }));
      });
    }
  }
};
const renderClock = variant => {
  if (variant) {
    return /*#__PURE__*/_react.default.createElement("svg", {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 5C4.5 5 0 9.5 0 15C0 20.5 4.5 25 10 25C15.5 25 20 20.5 20 15C20 9.5 15.5 5 10 5Z",
      fill: variant && variant === "product-trial-last-day" ? "#363545" : "#1E8A44"
    }), /*#__PURE__*/_react.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.2 19.2L9 16V10H10.5V15.2L15 17.9L14.2 19.2Z",
      fill: "#FFFDFD"
    }));
  }
};